import { combineEpics } from 'redux-observable';
import { epics as fdi } from './Dashboard';
import { epics as states } from './states';
// tslint:disable:no-any
const epic = combineEpics(
  ...Object.keys(states).map(k => states[k]),
  ...Object.keys(fdi).map(k => (fdi as any)[k]),
);

export default epic;



// WEBPACK FOOTER //
// ./src/epic.ts